var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.778 37.778c-2.778 0-5.445-.444-7.934-1.267a2.268 2.268 0 00-2.266.534l-4.89 4.889a33.434 33.434 0 01-14.644-14.645l4.89-4.911c.622-.578.8-1.445.555-2.222a25.246 25.246 0 01-1.267-7.934C22.222 11 21.222 10 20 10h-7.778C11 10 10 11 10 12.222 10 33.09 26.911 50 47.778 50 49 50 50 49 50 47.778V40c0-1.222-1-2.222-2.222-2.222zM45.556 30H50c0-11.044-8.956-20-20-20v4.445c8.6 0 15.556 6.955 15.556 15.555zm-8.89 0h4.445c0-6.133-4.978-11.111-11.111-11.111v4.445A6.658 6.658 0 0136.667 30z",
    fill: "#E3B05F"
  })));
}

export default SvgSell;